export default "__VITE_ASSET__cc9023ba__"